import { CSSProperties } from 'react';
import { PurpleContainer, PlatformsIconsContainer, CampaignTypeText, IconContainer } from 'modules/Sty';
import { clsx, styx } from 'modules/Utils';
import Icon from 'elements/Icon';

interface BadgeContainerProps {
    className?: string;
    style?: CSSProperties;
    text: string;
    imageUrls?: string[];
    icon?: string;
}

const BadgeContainer = ({
    className,
    style,
    text,
    imageUrls,
    icon,
}: BadgeContainerProps) => {
    return (
        <PurpleContainer
            className={clsx('badgeContainerComponent', className)}
            style={styx(sty.badgeContainerComponent, style)}
        >
            {imageUrls &&
                <PlatformsIconsContainer>
                    {imageUrls.map((url, index) => (
                        <IconContainer key={`${url}-${index}`}>
                            <img src={url} alt={`badge-image-${index}`} />
                        </IconContainer>
                    ))}
                    {icon &&
                        <Icon
                            className="badgeContainerIcon"
                            icon={icon}
                            size={16}
                        />
                    }
                </PlatformsIconsContainer>
            }
            <CampaignTypeText>
                {text}
            </CampaignTypeText>
        </PurpleContainer>
    );
};

const sty: Record<string, CSSProperties> = {
    badgeContainerComponent: {
        whiteSpace: 'nowrap',
    }
}

export default BadgeContainer;
